import React, {useEffect, useState} from 'react';
import {DatePicker, Select, Switch, Tooltip} from "antd";
import {Line} from "@ant-design/plots";
import {API_PATH} from "../../components/const";
import dayjs from "dayjs";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment/moment";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import * as XLSX from "xlsx";
const dateFormat = 'YYYY-MM';
const {RangePicker} = DatePicker;

const VisitorsComparasionDateMonthly = (props) => {
    const [time, setTime] = useState(new Date());
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    const [data, setData] = useState([]);
    const [offices, setOffices] = useState([])
    const [sendData, setSendData] = useState(null)
    const [companies, setCompanies] = useState([])
    const [show, setShow] = useState(false)
    const [parents, setParents] = useState([])
    const [filCameraList, setFilCameraList] = useState([])
    const [filSelectCamera, setSelectFilCamera] = useState([])
    const [date1, setdate1] = useState("")
    const [date11, setdate11] = useState("")
    const [date2, setdate2] = useState("")
    const [date22, setdate22] = useState("")

    function roundToTwoDecimals(num) {
        return Math.round(num * 100) / 100;
    }
    const exportToExcel = () => {
        // Ma'lumotlarni formatlash
        const formattedData = data.map((item, index) => ({
            "№": index + 1,
            "Первое дата": item?.date_interval_1,
            "Первое посетитель": item?.value_1,
            "Второе дата": item?.date_interval_2,
            "Второе посетитель ": item?.value_2,
            "Разница(%)": `${item?.diff_percent} %`,
            "Разница(число)": item?.diff_abs,
        }));

        // Jadvalni Excel formatiga aylantirish
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");

        // Faylni saqlash
        XLSX.writeFile(workbook, "table_data.xlsx");
    };


    function onChange(date, dateString) {
        const [year, month] = dateString.split('-').map(Number);

        const lastDate = new Date(year, month, 0);
        setdate11(dateString + "-" + lastDate.getDate()); // Oxirgi sana (kun)
        // setdate1(dateString)
        setdate1(dateString+"-"+"01")

    }
    function onChange2(date, dateString) {
        const [year, month] = dateString.split('-').map(Number);

        // Keyingi oyning 0-kunini olish
        const lastDate = new Date(year, month, 0);
        setdate22(dateString + "-" + lastDate.getDate()); // Oxirgi sana (kun)
        // setdate2(dateString)
        setdate2(dateString+"-"+"01")


    }

    const asyncFetch = (data) => {
        console.log(date1?.length > 0 && date11?.length > 0 && date2?.length > 0 && date22?.length > 0)
        // if (date1?.length > 0 && date11?.length > 0 && date2?.length > 0 && date22?.length > 0){
            axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/compare-custom-intervals?start_date1=" + date1 +"&end_date1=" + date11 + "&start_date2=" + date2 + "&end_date2=" + date22 + "&granularity=daily"  , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((json) => {
                        setData(json?.data)
                    }
                )
                .catch(() => {
                });

        // }
        // else{
        //     toast.error("Заполните поле")
        //
        // }


    };
    const onSwitch = () => {
        setShow(!show)
        asyncFetch()
    }
    const config = {


        data,
        xField: 'date_interval_1',
        yField: 'value_1',
        point: {
            shapeField: 'square',
            sizeField: 4,
            style: {
                fill: 'white',
                stroke: '#11da22',
                lineWidth: 2,
            },
        },
        interaction: {
            tooltip: {
                marker: false,
            },
        },
        style: {
            lineWidth: 2,
        },
        lineStyle: {
            stroke: '#11da22',
            lineWidth: 2,
        },

    };
    const config2 = {


        data,
        xField: 'date_interval_2',
        yField: 'value_2',
        point: {
            shapeField: 'square',
            sizeField: 4,
            style: {
                fill: 'white',
                stroke: '#dcb90e',
                lineWidth: 2,
            },
        },
        interaction: {
            tooltip: {
                marker: false,
            },
        },
        style: {
            lineWidth: 2,
        },
        lineStyle: {
            stroke: '#dcb90e',
            lineWidth: 2,
        },
    };

    useEffect(() => {
        // getBuilding()
        // getParentBuilding()
        // getFilCamera()

        setCompanies(localStorage.getItem("com1data")?.split(',').map(Number))
    }, [show]);
    return (
        <div>
            <div className="visitor visitor-box">
                <div className="chart-box">
                    <div className="visitor-title">
                        <h1>
                            <span className="font-family-medium">
                      Посетитель ежемесячно
                        </span>

                            <div className="d-flex align-items-center my-multi-select">



                                <div className="inputs-box mr-24 remove-back-select" style={{marginTop: "-7px"}} >
                                    <Select
                                        showSearch
                                        placeholder="Выберите тип"
                                        optionFilterProp="children"
                                        className="w-100"
                                        value={props?.seldate}
                                        onChange={(e) => props.setseldate(e)}
                                        options={props.selList?.map((item) => {
                                            return {
                                                value: item.value,
                                                label:
                                                item?.name
                                            };
                                        })}
                                    />
                                </div>

                                <div className="mr-24 d-flex align-items-center">



                                    <DatePicker picker="month"
                                                onChange={onChange}
                                                placeholder="Выберите месяц"
                                                format={dateFormat}
                                    />

                                    <h4 className="text-white mb-0 ml-8 mr-8">-</h4>


                                    <DatePicker picker="month"
                                                onChange={onChange2}
                                                placeholder="Выберите месяц"
                                                format={dateFormat}
                                    />



                                </div>
                                <button style={{fontSize: "14px"}} onClick={asyncFetch}
                                        className="ml-16 mt-2 add-btn">Сравнивать
                                </button>
                            </div>


                        </h1>
                    </div>
                    <div className="d-flex w-100">
                        <div className="w-100 p-3">
                            <Line {...config} />
                        </div>
                        <div  className="w-100 p-3">
                            <Line {...config2} />

                        </div>


                    </div>
                    {
                        data?.length > 0
                            ?
                            <div className="emp-table mt-4 ">
                                <div className="d-flex justify-content-between">
                                    <button type="submit" className="add-btn mb-3" onClick={() => setShow(!show)}>Посмотреть таблицу</button>
                                    <button type="submit" className="btn btn-success mb-3" onClick={exportToExcel}>Скачать таблицу</button>
                                </div>
                                {
                                    show ?
                                        <TableContainer component={Paper}>
                                            <Table sx={{minWidth: 650}} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className="pl20 table-head">№</TableCell>
                                                        <TableCell className="  table-head">Первое дата</TableCell>
                                                        <TableCell className="table-head" align="left">Посетитель</TableCell>
                                                        <TableCell className="table-head" align="left">Второе дата</TableCell>
                                                        <TableCell className="table-head" align="left">Посетитель</TableCell>
                                                        <TableCell className="table-head" align="left"> Разница(%)</TableCell>
                                                        {/*<TableCell className="table-head"  align="left">25.12.2023</TableCell>*/}
                                                        <TableCell className="pr20 table-head" align="right">Разница(число)</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data.map((item, index) => (
                                                        <TableRow
                                                            key={item?.name}
                                                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                                        >
                                                            <TableCell className="pl20" scope="row">
                                                                <div className="tabel-item">
                                                                    {index + 1}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell  scope="row">
                                                                <div className="tabel-item">
                                                                    {item?.date_interval_1}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className="pl20" scope="row">
                                                                <div className="tabel-item">
                                                                    {item?.value_1}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell scope="row">
                                                                <div className="tabel-item">
                                                                    {item?.date_interval_2}
                                                                </div>
                                                            </TableCell>

                                                            <TableCell align="left">
                                                                <div className="tabel-item">
                                                                    {item?.value_2}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                <div className="tabel-item">

                                                                    <span className="mr-4">{roundToTwoDecimals(item?.diff_percent)} %</span>
                                                                    {
                                                                        roundToTwoDecimals(item?.diff_percent) > 0
                                                                            ?
                                                                            <span className="up2">
                                                                     рост <img src="/icon/downa.svg" alt=""/>
                                                                </span>
                                                                            : roundToTwoDecimals(item?.diff_percent) < 0 ?
                                                                                <span className="down2">
                                                                    спад<img src="/icon/upa.svg"  alt=""/>
                                                                </span> :
                                                                                ""
                                                                    }


                                                                </div>
                                                            </TableCell>
                                                            <TableCell className="  con-btns-all" align="right">
                                                                <div className="tabel-item tabel-item-controls">
                                                                    {item?.diff_abs}

                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        :
                                        ""
                                }

                            </div>
                            :
                            ""
                    }
                </div>
            </div>
        </div>
    );
};

export default VisitorsComparasionDateMonthly